/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProductPricingType {
  Default = 0,
  'System Sized' = 1,
  'Roof Sized' = 2,
}
